export default __webpack_public_path__ + "8164716b441dc3be17a4203069ef9897.png";